"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/ui/tooltip";

import Link from "next/link";
import { cn } from "@punchup/utils/cn";
import { useShowRowContext } from "@/components/shows/ShowRowContext";

interface ShowRowVenueProps {
  multipleVenues?: boolean;
  withTooltip?: boolean;
  className?: string;
}

export function ShowRowVenue({
  multipleVenues = false,
  withTooltip = false,
  className,
}: ShowRowVenueProps) {
  const { shows, venueSlug } = useShowRowContext();
  const venue = shows[0].venue;

  const baseClassName = cn(
    "text-sm font-semibold text-secondary-blue uppercase",
    className
  );

  if (multipleVenues) {
    return <p className={baseClassName}>Multiple venues</p>;
  }

  const element = venueSlug ? (
    <Link
      href={`/v/${venueSlug}`}
      className={cn(baseClassName, "hover:underline underline-offset-2")}
      onClick={(e) => e.stopPropagation()}
    >
      {venue}
    </Link>
  ) : (
    <p className={baseClassName}>{venue}</p>
  );

  if (withTooltip) {
    return (
      <TooltipProvider>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>{element}</TooltipTrigger>
          <TooltipContent sideOffset={5} className="max-w-xs text-sm">
            {venue}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return element;
}
